import { ALGOLIA_INDEX_NAME } from '@/lib/algolia/searchClient';
import { HOST } from '@/lib/host';
import { CreateURL, UiState } from 'instantsearch.js';

function removeEmpty(obj: { [k: string]: any }) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
}

export const createURL: CreateURL<{
  qsModule: any;
  routeState: UiState;
  location: Location;
}> = ({ qsModule, routeState, location }) => {
  const state = routeState[ALGOLIA_INDEX_NAME];
  const refineMentList: { [attribute: string]: string[] } =
    state.refinementList || {};

  // Translate refinements
  Object.keys(refineMentList).map((key) => {
    if (state.refinementList) {
      if (key === 'colour') {
        refineMentList.farge = state.refinementList[key];
        delete refineMentList.colour;
      }
      if (key === 'storesWithStockOrDisplay') {
        refineMentList.lager = state.refinementList[key];
        delete refineMentList.storesWithStockOrDisplay;
      }
      if (key === 'articleGroups.lvl1') {
        refineMentList.category = state.refinementList[key];
        delete refineMentList['articleGroups.lvl1'];
      }
    }
  });

  const pris = state?.range?.price ? `${state.range.price}` : null;
  const sortering = state?.sortBy ? `${state.sortBy}` : null;

  const q = state?.query ? `${state.query}` : undefined;

  const params = removeEmpty({
    pris,
    sortering,
    q,
    ...refineMentList,
  });

  const paramsString = qsModule.stringify(params, {
    arrayFormat: 'repeat',
  });

  const newUrl =
    HOST +
    (params && Object.keys(params).length > 0
      ? location.pathname + `?${paramsString}`
      : location.pathname);

  // console.log('newUrl', newUrl);
  return newUrl;
};
